export function asLinkAltClick(ev: any, onClick: Function) {
    if (!ev.metaKey) {
        if (ev) { ev.preventDefault(); }
        onClick();
    }
}
